import { combineEpics } from 'redux-observable';

import { continueApplicationProcessingEpic } from './continue-application-processing.epic';
import { nextStepEpic } from './next-step.epic';

const applicationEpic = combineEpics(nextStepEpic, continueApplicationProcessingEpic);

export { applicationEpic };
